export function validateEmail(email) {
	if (typeof email == "string" && email.length <= 254) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,63}))$/;
		return re.test(String(email).toLowerCase());
	} else {
		return false;
	}
}

export function base64encode(string) {
	return Buffer.from(string).toString('base64url');
}

export function base64decode(string) {
	return Buffer.from(string, 'base64url').toString('utf-8');
}

export function randomId() {
	return String(Math.floor(Math.random()*10000000));
}

export function formatCost(cost) {
	return "$" + cost.toFixed(2);
}

export function shuffle(a) {
	var j, x, i;
	for (i = a.length - 1; i > 0; i--) {
		j = Math.floor(Math.random() * (i + 1));
		x = a[i];
		a[i] = a[j];
		a[j] = x;
	}
	return a;
}

export function convertAgeToYears(patient_age) {
	if (patient_age && patient_age.unit && String(patient_age.number).length > 0 && !isNaN(String(patient_age.number))) {
		if (patient_age.unit == "years") {
			return Number(patient_age.number);
		} else if (patient_age.unit == "months") {
			return Number(patient_age.number) / 12;
		} else if (patient_age.unit == "weeks") {
			return Number(patient_age.number) / 52;
		} else if (patient_age.unit == "days") {
			return Number(patient_age.number) / 365;
		} else if (patient_age.unit == "hours") {
			return Number(patient_age.number) / 8760;
		}
	} else {
		return null;
	}
}

export function compareObjects(obj1, obj2) {
  // Handle non-objects
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return obj1 == obj2;
  }
  
  // Handle null
  if (obj1 === null || obj2 === null) {
    return obj1 == obj2;
  }

  // Handle arrays
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) return false;
    return obj1.every((val, idx) => compareObjects(val, obj2[idx]));
  }

  // Get sorted keys
  const keys1 = Object.keys(obj1).sort();
  const keys2 = Object.keys(obj2).sort();

  // Compare keys
  if (keys1.length !== keys2.length) return false;
  if (!keys1.every((key, i) => key === keys2[i])) return false;

  // Compare values
  return keys1.every(key => compareObjects(obj1[key], obj2[key]));
}

export function timeSince(datetime, now = Date.now()) {

	var msPerMinute = 60 * 1000;
	var msPerHour = msPerMinute * 60;
	var msPerDay = msPerHour * 24;
	var msPerMonth = msPerDay * 30;
	var msPerYear = msPerDay * 365;

	var elapsed = now - datetime;

	if (elapsed < msPerMinute) {
		return 'Just now';
	}

	else if (elapsed < msPerHour) {
		if (Math.round(elapsed / msPerMinute) == 1) {
			return '1 min ago';
		} else {
			if (Math.round(elapsed / msPerMinute) == 60) {
				return '1 hour ago';
			} else {
				return Math.round(elapsed / msPerMinute) + ' mins ago';
			}
		}
	}

	else if (elapsed < msPerDay) {
		if (Math.round(elapsed / msPerHour) == 1) {
			return '1 hour ago';
		} else {
			return Math.round(elapsed / msPerHour) + ' hours ago';
		}
	}

	else if (elapsed < msPerMonth) {
		if (Math.round(elapsed / msPerDay) == 1) {
			return '1 day ago';
		} else {
			if (Math.round(elapsed / msPerDay) > 6) {
				if (Math.round(elapsed / msPerDay) > 13) {
					if (Math.round((Math.round(elapsed / msPerDay)) / 7) == 4) {
						return '1 month ago';
					} else {
						return Math.round((Math.round(elapsed / msPerDay)) / 7) + ' weeks ago';
					}
				} else {
					return '1 week ago';
				}
			} else {
				return Math.round(elapsed / msPerDay) + ' days ago';
			}
		}
	}

	else if (elapsed < msPerYear) {
		if (Math.round(elapsed / msPerMonth) == 1) {
			return '1 month ago';
		} else {
			if (Math.round(elapsed / msPerMonth) == 12) {
				return '1 year ago';
			} else {
				return Math.round(elapsed / msPerMonth) + ' months ago';
			}
		}
	}

	else {
		if (Math.round(elapsed / msPerYear) == 1) {
			return '1 year ago';
		} else {
			return Math.round(elapsed / msPerYear) + ' years ago';
		}
	}
}

export function timeTaken(datetime) {
  const days = Math.floor(datetime / (1000 * 60 * 60 * 24));
  const hours = Math.floor((datetime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((datetime % (1000 * 60 * 60)) / (1000 * 60));

  if (days === 0) {
    if (hours === 0) {
      return `${minutes} min`;
    }
    return `${hours} hr${minutes > 0 ? `, ${minutes} min` : ''}`;
  }
  return `${days} d${hours > 0 ? `, ${hours} hr` : ''}${minutes > 0 ? `, ${minutes} min` : ''}`;
}

export function formatDate(datetime, lowercase = false) {
	const date = new Date(datetime);
	const today = new Date();
	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - 1);

	if (isSameDay(date, today)) {
		return `${lowercase ? "today" : "Today"}, ${new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric' }).format(date)}`;
	} else if (isSameDay(date, yesterday)) {
		return `${lowercase ? "yesterday" : "Yesterday"}, ${new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric' }).format(date)}`;
	} else {
		const options = { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
		if (date.getFullYear() !== today.getFullYear()) {
			options.year = 'numeric';
		}
		return new Intl.DateTimeFormat('en-US', options).format(date);
	}
}

export function isSameDay(d1, d2) {
	return d1.getDate() === d2.getDate() && 
				 d1.getMonth() === d2.getMonth() && 
				 d1.getFullYear() === d2.getFullYear();
}

export function compareRubricArrays(rubrics1, rubrics2) {
	if (rubrics1.length !== rubrics2.length) {
		return false;
	}

	for (let i = 0; i < rubrics1.length; i++) {
		const rubric1 = rubrics1[i];
		const rubric2 = rubrics2[i];

		if (rubric1._id !== rubric2._id ||
			rubric1.version_id !== rubric2.version_id ||
			rubric1.is_linked !== rubric2.is_linked ||
			JSON.stringify(rubric1.data) !== JSON.stringify(rubric2.data)) {
			return false;
		}
	}

	return true;
}

export function truncateString(str, maxLength) {
  if (!str || str.length <= maxLength) return str;
  
  // Use Intl.Segmenter for proper grapheme cluster handling (modern browsers)
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    const segmenter = new Intl.Segmenter('en', { granularity: 'grapheme' });
    const segments = Array.from(segmenter.segment(str));
    
    if (segments.length <= maxLength) return str;
    
    return segments.slice(0, maxLength).map(s => s.segment).join('') + '...';
  }
  
  // Fallback: Use Array.from to respect surrogate pairs (basic emoji support)
  const chars = Array.from(str);
  if (chars.length <= maxLength) return str;
  
  return chars.slice(0, maxLength).join('') + '...';
}

export function shortDate(datetime) {
	const date = new Date(datetime);
	const today = new Date();
	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - 1);

	if (isSameDay(date, today)) {
		return new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric' }).format(date);
	} else {
		const options = { month: 'short', day: 'numeric' };
		if (date.getFullYear() !== today.getFullYear()) {
			options.year = 'numeric';
		}
		return new Intl.DateTimeFormat('en-US', options).format(date);
	}
}

export function shortDateTime(datetime) {
	const date = new Date(datetime);
	const today = new Date();
	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - 1);

	if (isSameDay(date, today)) {
		return new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric' }).format(date);
	} else {
		const options = { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
		if (date.getFullYear() !== today.getFullYear()) {
			options.year = 'numeric';
		}
		return new Intl.DateTimeFormat('en-US', options).format(date);
	}
}

const removeNonSpeechUtterances = ["[lip smacks]"];

export function correctUtterance(text) {
  let result = text;
  for (const phrase of removeNonSpeechUtterances) {
    const escaped = phrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    result = result.replace(new RegExp("( ?)" + escaped + "( ?)", "g"), (_, before, after) => (before && after) ? " " : "");
  }
  return result.trim();
}

export function getDocumentationTypeName(s) {
	const { documentation_type, encounter_stages, conversation_based_objective, write_conversation_summary, diagnosis_and_management, write_documentation } = s;

	if (conversation_based_objective && write_conversation_summary && !(diagnosis_and_management && write_documentation)) {
		return "Conversation summary";
	} else if (documentation_type === "hpi") {
		return "HPI";
	} else if (documentation_type === "assessment_and_plan") {
		if (encounter_stages === "plan") {
			return "Assessment and Plan";
		} else {
			return "Final Assessment";
		}
	} else if (documentation_type === "soap") {
		if (encounter_stages === "plan") {
			return "SOAP note";
		} else {
			return "Partial SOAP note";
		}
	} else if (documentation_type === "hp") {
		if (encounter_stages === "plan") {
			return "H&P";
		} else {
			return "Partial H&P";
		}
	}
	return "Documentation";
}

export function getConversationTypeName(s) {
	const { conversation_focus, conversation_focus_other } = s;

	if (conversation_focus === "other") {
		return conversation_focus_other;
	}

	return {
		"counseling": "Patient education / counseling",
		"goals_of_care": "Goals of care conference",
		"delivering_bad_news": "Delivering bad news",
		"error_disclosure": "Error disclosure",
		"obtaining_consent": "Obtaining consent",
	}[conversation_focus];
}